module.exports = __webpack_public_path__ + "img/pendingAttach.432b21f6.svg";